import { Controller } from "@hotwired/stimulus"

// Locks the export button while a faces ZIP job is running, and auto-starts
// download when Turbo replaces the status partial with auto_download set.
export default class extends Controller {
  static targets = ["exportButton", "download", "status"]
  static values = {
    autoDownload: { type: String, default: "" },
    running: { type: Boolean, default: false }
  }

  connect() {
    this.#syncExportLock()
    if (this.autoDownloadValue) {
      this.#triggerDownload(this.autoDownloadValue)
    }
  }

  runningValueChanged() {
    this.#syncExportLock()
  }

  start() {
    if (!this.hasExportButtonTarget) return
    // Visual lock only — disabling synchronously would cancel the form submit.
    this.exportButtonTarget.classList.add("is-loading")
    this.exportButtonTarget.setAttribute("aria-busy", "true")
  }

  #syncExportLock() {
    if (!this.hasExportButtonTarget) return
    this.exportButtonTarget.disabled = this.runningValue
    this.exportButtonTarget.classList.toggle("is-loading", this.runningValue)
  }

  #triggerDownload(url) {
    const anchor = document.createElement("a")
    anchor.href = url
    anchor.setAttribute("download", "catalog-faces.zip")
    anchor.style.display = "none"
    document.body.appendChild(anchor)
    anchor.click()
    anchor.remove()
  }
}
